<template>
  <div class="container">
  <ol class="breadcrumb">
    <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
    <li class="active">License Expiry</li>
  </ol>

  <bootstrap-modal v-for="(license, index) in filteredActivations" title="License Details" :name="'attributesJson' + index">
    <json v-bind:jsonObject="license.attributes"></json>
  </bootstrap-modal>

  <div class="row">
    <div class="col-sm-6">
      <date-range-picker @daterange-change="dateRangeChange" placeHolder="Licenses Issued Between" :ranges="datePickerRanges"></date-range-picker>
    </div>
    <div class="col-sm-6">
      <h5>{{ dateRangeFormat(dateStart) }} - {{ dateRangeFormat(dateEnd) }}</h5>
    </div>
  </div>

  <form class="form-inline">
    <div class="form-group">
      <label for="activationsExpiredInput">Activations expired in last (days)</label>
      <input v-model="expiresAgoDays" :value="expiresAgoDays" type="text" class="form-control" id="activationsExpiredInput" placeholder="days">
    </div>
    <div class="form-group">
      <label for="activationsWillExpireDays">or in the next (days)</label>
      <input v-model="expiresInDays" :value="expiresInDays" type="text" class="form-control" id="activationsWillExpireDays" placeholder="days">
    </div>
  </form>

  <!-- {{ licenses }} -->
  <!-- {{ serialDetails }} -->
  <!-- {{ activations }} -->

  <div v-if="filteredActivations.length > 0">
    <p>Showing {{ licenseCount }} license activations</p>

  <table class="table">
    <thead>
      <th>Activation Date</th>
      <th>Serial</th>
      <th>Customer</th>
      <th>Expiry Date</th>
      <th>Expires</th>
      <th>Details</th>
    </thead>
    <tbody>
      <tr v-for="(lic, index) in filteredActivations" v-bind:class="lic.rowClass">
        <td>{{ formatDate(lic.activation.activateTime) }}</td>
        <td>
          <router-link :to="{ name: 'serial', params: { id: lic.activation.serial }}">{{ trim(lic.activation.serial, 8) }}</router-link>
        </td>
        <td>{{ serialDetails[lic.activation.serial] ? serialDetails[lic.activation.serial].customer : '' }}</td>
        <td>{{ lic.licenseExpiryDate.format('YYYY-MM-DD HH:mm') }}</td>
        <td>{{ Math.abs(lic.expiryDays) }} {{ lic.expiryDays < 0 ? 'days ago' : 'days'}}</td>
        <td v-if="'attributes' in lic"><a :href="'#attributesJson' + index" data-toggle="modal">show</a></td>
        <td v-else></td>
      </tr>
    </tbody>
  </table>

  </div>
  <div v-else>
    <span>No license activations.</span>
  </div>
  </div>
</div>
</template>

<style scoped>
span {
  padding: 1em;
}
h5 {
  margin-left: 1em;
}
.checkbox-inline {
  margin-right: 1em;
}
input[type="checkbox"] {
  margin-right: 0.25em;
}
</style>

<script>
import _ from 'underscore'
import moment from 'moment'
import * as mutationTypes from '../store/mutation-types'
import licenseLib from '../lib/license'
import DateRangePicker from './DateRangePicker'
import BootstrapModal from './BootstrapModal'
import Json from './Json'
import C from '../constants'

export default {
  components: {
    BootstrapModal,
    DateRangePicker,
    Json
  },

  data () {
    return {
      licenses: [],
      serials: [],

      datePickerRanges: {
        'Last 30 days': [ moment().subtract(30, 'days'), moment() ],
        'Last 90 days': [ moment().subtract(90, 'days'), moment() ],
        'Last 180 days': [ moment().subtract(180, 'days'), moment() ],
        'Last year': [ moment().subtract(1, 'years'), moment() ],
        'Last 2 years': [ moment().subtract(2, 'years'), moment() ]
      }
    }
  },

  computed: {
    dateRange: {
      get () {
        return this.$store.state.filterReportLicenseExpiry.dateRange
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE, value)
      }
    },
    expiresInDays: {
      get () {
        return this.$store.state.filterReportLicenseExpiry.expiresInDays
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS, value)
      }
    },
    expiresAgoDays: {
      get () {
        return this.$store.state.filterReportLicenseExpiry.expiresAgoDays
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS, value)
      }
    },
    dateStart () {
      return moment(this.dateRange[0], C.M_FMT_MS).utc()
    },

    dateEnd () {
      return moment(this.dateRange[1], C.M_FMT_MS).utc()
    },
    epochStart () {
      return this.dateRange[0]
    },
    epochEnd () {
      return this.dateRange[1]
    },
    licenseCount () {
      return this.filteredActivations.length
    },
    serialDetails () {
      return _.mapObject(this.serials, (item) => {
        return {
          customer: item.details.length > 0 ? item.details[0].customer : ''
        }
      })
    },
    activations () {
      var licenseActivations = []
      _.each(this.licenses, (license) => {
        _.each(license.activations, (activation) => {
          var licenseActivation = _.clone(license.license)
          if (activation.installed === 1) {
            licenseActivation.activation = activation
            licenseActivation.attributes = license.attributes
            licenseActivation.duration = license.attributes.license.root.duration
            licenseActivation.expires = license.attributes.license.root.expires
            licenseActivation.licenseExpiryDate = licenseLib.licenseExpiryDate(activation.activationDate, licenseActivation.expires, licenseActivation.duration)
            licenseActivation.expiryDays = licenseActivation.licenseExpiryDate.diff(moment(), 'days')
            licenseActivation.customer = this.serialDetails[activation.serial] ? this.serialDetails[activation.serial].customer : license.attributes.license.root.customer
            licenseActivation.rowClass = licenseActivation.expiryDays < 0 ? 'danger' : ''
            licenseActivations.push(licenseActivation)
          }
        })
      })
      return licenseActivations
    },
    filteredActivations () {
      return _.chain(this.activations)
      .filter((activation) => {
        if (activation.customer === 'Wedge R&D') {
          return false
        }
        if (activation.expiryDays > this.expiresInDays || activation.expiryDays < -this.expiresAgoDays) {
          return false
        }
        return true
      })
      .sortBy('expiryDays')
      .value()
    }
  },

  methods: {
    fetch () {
      this.$store.commit(mutationTypes.LOADER_LOADING)
      Promise.all([
        this.$apiWsoc.fetchLicenses(null, this.epochStart, this.epochEnd),
        this.$apiWsoc.fetchDetails(null, this.epochStart, this.epochEnd)
      ])
      .then(([licenseResult, detailsResult]) => {
        this.$store.commit(mutationTypes.LOADER_NOT_LOADING)
        this.licenses = licenseResult.result
        this.serials = detailsResult
      })
      .catch((error) => {
        this.$store.commit(mutationTypes.LOADER_NOT_LOADING)
        console.log('error fetching', error)
      })
    },
    trim (str, length) {
      return str.substring(0, length)
    },
    formatDate (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    dateRangeFormat (date) {
      return moment(date).format(C.M_FMT_READABLE_WEEKDAY)
    },
    dateRangeChange (e) {
      this.dateRange = e
    }
  },

  mounted () {
    this.fetch()
  },

  watch: {
    dateRange: function () {
      this.fetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportLicenseExpiry.vue?366bd3e0